import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import Input from "../../components/Input";
import Spinner from "../../components/Spinner";
import { TH, THeadTR } from "../../components/Table v2";
import logoContrastWithoutName from "../../image/logoContrastWithoutName.svg";
import "./index.scss";

export function Prices() {
  const [users, setUsers] = useState<number>(1);
  const [valuePlan, setValuePlan] = useState(11.99);
  const [annualPlan, setAnnualPlan] = useState(9.99);

  const valuesPlan = [
    {
      "limit-users": 5,
      "value-month": 11.99,
      "value-year": 9.99,
    },
    {
      "limit-users": 10,
      "value-month": 10.99,
      "value-year": 8.99,
    },
    {
      "limit-users": 20,
      "value-month": 8.99,
      "value-year": 6.99,
    },
    {
      "limit-users": 50,
      "value-month": 7.99,
      "value-year": 5.99,
    },
    {
      "limit-users": 51,
      "value-month": 6.99,
      "value-year": 4.99,
    },
  ];

  function planMonth() {
    let plan = undefined;
    if (users >= 51) plan = valuesPlan[valuesPlan.length - 1];
    else plan = valuesPlan.find((plan) => users <= plan["limit-users"]);
    return plan["value-month"];
  }

  function planYear() {
    let plan = undefined;
    if (users >= 51) plan = valuesPlan[valuesPlan.length - 1];
    else plan = valuesPlan.find((plan) => users <= plan["limit-users"]);
    return plan["value-year"];
  }

  return (
    <>
      <div className="prices flex flex-col">
        <div className="flex justify-between items-center w-full h-20 bg-primary mb-3 px-56">
          <span className="flex items-center">
            <img src={logoContrastWithoutName} className="w-28" />
            <h1 className="text-3xl font-semibold items-center">integra admin</h1>
          </span>
          <span>
            <Button>
              <Button className="bg-yellow-300 text-white font-bold rounded-full px-28">
                <Link className="btn" to={"/login"}>
                  Faça o Login
                </Link>
              </Button>
            </Button>
          </span>
        </div>
        <div className="flex flex-col justify-center w-11/12 mx-10">
          <div className="flex justify-center items-center mb-5"></div>
          <div className="w-full teste flex justify-center shadow-2xl rounded-3xl bg-primary px-10">
            <div className="flex flex-col h-full w-full items-center">
              <div className="w-full mt-5 text-white text-center">
                <h2 className="text-5xl font-bold">Planos</h2>
                <p className="text-4xl mt-2 font-semibold">Faça uma simulação para escolher o plano ideal para sua equipe</p>
              </div>
              <div className="mt-5 w-1/5 text-center">
                <Input
                  className="input-prices-users flex"
                  type="number"
                  name={"employees"}
                  label={"Quantos usuários você tem?"}
                  placeholder={"Digite a quantidade"}
                  value={users}
                  setValue={(e) => {
                    setUsers(e.target.value);
                  }}
                />
              </div>
              <p className="text-5xl mt-2 font-semibold">
                Teste <strong>grátis</strong> por <strong>30 dias</strong>
              </p>

              {/*---------------------------- Mensal -----------------------------------------------------*/}

              <div className="flex flex-row h-5/6 w-full justify-center items-center">
                <div className="cards-price flex flex-col justify-evenly items-center bg-white shadow-xl rounded-l-2xl">
                  <h2 className="text-3xl font-familyPoppins font-bold text-gray-500">Mensal</h2>
                  <p className="flex items-center text-5xl font-familyPoppins font-bold text-gray-700 gap-2">
                    <span className="text-gray-500 font-normal text-4xl">R$</span> {planMonth()}
                    <span className="text-gray-500 font-normal italic text-lg">por usuário</span>
                  </p>
                  <p className="text-2xl font-familyPoppins font-bold text-gray-500">R$ {(planMonth() * users).toFixed(2)} mensais</p>
                  <p className="text-2xl text-center font-familyPoppins text-gray-500">Pagamento mensal</p>
                  <Link className="text-green-400 font-bold" to={"/signup"}>
                    <Button className="bg-white border-2 border-green-500">Obter agora</Button>
                  </Link>
                </div>

                {/*---------------------------- Anual -----------------------------------------------------*/}

                <div className="cards-price-principal flex flex-col justify-around items-center bg-white shadow-2xl rounded-2xl -ml-4">
                  <div className="content-principal flex flex-col items-center justify-evenly gap-2">
                    <div className="justify-center rounded-t-2xl -my-9">
                      <span className="text-2xl font-bold text-primary">Recomendado</span>
                    </div>
                    <h2 className="text-3xl font-familyPoppins font-bold p-1 text-gray-500">Anual</h2>
                    <p className="flex items-center text-5xl font-familyPoppins font-bold text-gray-700 gap-2">
                      <span className="text-gray-500 font-normal text-4xl">R$</span> {planYear()}
                      <span className="text-gray-500 font-normal italic text-lg">por usuário</span>
                    </p>
                    <span className="text-2xl font-familyPoppins font-bold text-gray-500">R${(planYear() * users).toFixed(2)} mensais</span>
                    <span className="text-2xl text-center font-familyPoppins text-gray-500 m-1">
                      {users ? <>Pague anualmente e economize {Math.ceil(100 - (planYear() * 100) / planMonth())}%</> : <>Pagamento anual</>}
                    </span>
                    <Link className="text-white" to={"/signup"}>
                      <Button className="bg-green-400 text-white font-bold">Obter agora</Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="flex justify-center mt-5">
            <span className="text-3xl text-gray-700">
              Copyright &copy; 2022 <strong>IntegraAdmin.</strong> All Rights Reserved.
            </span>
          </footer>
        </div>
      </div>
    </>
  );
}
